__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/572327e/_next/";